var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailOpened(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#A9CF4B",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9504 32.5163L35.9312 23.4053C36.3118 23.1384 36.7659 22.9966 37.2305 23.0001C37.6954 23.0033 38.1475 23.1516 38.5239 23.4243L51.0791 32.5091C51.4283 32.7623 51.6965 33.111 51.8518 33.5133L38.1174 44.4242C37.4275 44.8215 36.5783 44.8215 35.8883 44.4242L22.1597 33.5177C22.3204 33.114 22.5956 32.766 22.951 32.5163L22.9504 32.5163ZM22.3175 51.1351C22.1097 50.7894 21.9998 50.3934 22 49.9899V34.8192L33.4884 43.9454L22.3175 51.1351ZM24.2332 52.2231C23.8494 52.2233 23.4723 52.1239 23.1383 51.935L34.4117 44.6769L35.2491 45.3442L35.2813 45.3631V45.3629C35.8 45.6734 36.3934 45.8374 36.9981 45.8374C37.6027 45.8374 38.1959 45.6734 38.7149 45.3629L38.747 45.3439L40.1099 44.2614L50.5927 52.0644C50.33 52.1693 50.0498 52.2234 49.7669 52.2234L24.2332 52.2231ZM51.5246 51.3655L41.0163 43.5428L52 34.8191V49.9911C51.9998 50.4896 51.8323 50.9734 51.5242 51.3651L51.5246 51.3655Z",
    fill: "#A9CF4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOpened);
export default __webpack_public_path__ + "static/media/emailOpened.54cab40662c3eb834b0362a5c8991385.svg";
export { ForwardRef as ReactComponent };